/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteAgentConnectorRequest = {
  /**
   * The agent ID.
   */
  id: string;
  /**
   * The connector ID.
   */
  connectorId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteAgentConnectorRequest$inboundSchema: z.ZodType<
  DeleteAgentConnectorRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteAgentConnectorRequest$Outbound = {
  id: string;
  connectorId: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteAgentConnectorRequest$outboundSchema: z.ZodType<
  DeleteAgentConnectorRequest$Outbound,
  z.ZodTypeDef,
  DeleteAgentConnectorRequest
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteAgentConnectorRequestToJSON(
  deleteAgentConnectorRequest: DeleteAgentConnectorRequest,
): string {
  return JSON.stringify(
    DeleteAgentConnectorRequest$outboundSchema.parse(
      deleteAgentConnectorRequest,
    ),
  );
}
export function deleteAgentConnectorRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteAgentConnectorRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteAgentConnectorRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteAgentConnectorRequest' from JSON`,
  );
}
